import { GET_PATIENT_DETAIL_SUCCESS } from "../actions/patientAction"

const patientDetailsReducer = (state = [], { type,  data={} }) => {
  switch (type) {
    case GET_PATIENT_DETAIL_SUCCESS:
      return data
    default:
      return state
  }
}
  
export default patientDetailsReducer